import { useState, useEffect } from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";

export default function Layout({ children }) {

  const [open, setOpen] = useState(window.innerWidth >= 992);

  useEffect(() => {

    const handleResize = () => {
      if (window.innerWidth < 992) {
        setOpen(false);   // close on mobile
      } else {
        setOpen(true);    // open on desktop
      }
    };

    window.addEventListener("resize", handleResize);

    // run once on load
    handleResize();

    return () => window.removeEventListener("resize", handleResize);

  }, []);

  return (
    <>
      <Sidebar open={open} close={() => setOpen(false)} />

      <div className={`main-area ${open ? "" : "w-100"}`}>
        <Header toggleSidebar={() => setOpen(!open)} />

        <div className="py-4">
          {children}
        </div>
      </div>
    </>
  );
}